/* The existing homepage places Swiper 11 last before DOMContentLoaded.
 * Share that dependency and download it without blocking HTML parsing. */
(() => {
  if (window.ComfortFlexSwiper) return;
  const url = document.currentScript.dataset.swiperSrc;
  let pending;
  window.ComfortFlexSwiper = {
    load() {
      if (pending) return pending;
      pending = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => {
          if (window.Swiper) resolve(window.Swiper);
          else reject(new Error('Swiper did not provide its constructor'));
        };
        script.onerror = () => reject(new Error('Swiper dependency failed to load'));
        document.head.appendChild(script);
      });
      return pending;
    }
  };
})();
